var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var KaroIcon = function (props) {
    return (_jsxs("svg", __assign({ width: "13", height: "12", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M10.2986 5.87689L6.67277 1.28746C6.58875 1.17141 6.41522 1.17141 6.32754 1.28565L2.70355 5.86964C2.64692 5.94398 2.6451 6.04734 2.70173 6.1235L6.32754 10.7129C6.41157 10.829 6.5851 10.829 6.67277 10.7147L10.2968 6.13075C10.3534 6.05459 10.3552 5.95124 10.2986 5.87689Z", fill: "url(#paint0_linear_9374_26108)" }), _jsx("defs", { children: _jsxs("linearGradient", { id: "paint0_linear_9374_26108", x1: "6.50016", y1: "1.2002", x2: "6.50016", y2: "10.8002", gradientUnits: "userSpaceOnUse", children: [_jsx("stop", { "stop-color": "#F0052F" }), _jsx("stop", { offset: "1", "stop-color": "#940136" })] }) })] })));
};
export default KaroIcon;
